export const getters = {
  saleItemsrows: state => state.sale_items,
  systemSales: state => state.sales
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/sales/getters.js